export const queryUrl = async url => {
  let result = []
  try {
    const body = await fetch(url)
    result = await body.json()
    return result
  } catch (e) {
    console.error(e)
  }
  return result
}
